/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/audit-reports-api-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/audit-reports-api-client";
import type { CreateGipReportMutationRequest, CreateGipReportMutationResponse, CreateGipReport400, CreateGipReport500 } from "../models/CreateGipReport";

export function getCreateGipReportUrl() {
  const res = { method: 'POST', url: `/reports/gip/report` as const }
  return res
}

/**
 * @summary Create new report
 * {@link /reports/gip/report}
 */
export async function createGipReport(data: CreateGipReportMutationRequest, config: Partial<RequestConfig<CreateGipReportMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<CreateGipReportMutationResponse, ResponseErrorConfig<CreateGipReport400 | CreateGipReport500>, CreateGipReportMutationRequest>({ method : "POST", url : getCreateGipReportUrl().url.toString(), data : requestData, ... requestConfig })
  return res.data
}